// extracted by mini-css-extract-plugin
export default {"contents-container":"BvRhzRUJwRZbA5tQTRu6"};